import { render } from "./EditDeliveryList.vue?vue&type=template&id=314b06f7&scoped=true"
import script from "./EditDeliveryList.vue?vue&type=script&lang=ts"
export * from "./EditDeliveryList.vue?vue&type=script&lang=ts"

import "./EditDeliveryList.vue?vue&type=style&index=0&id=314b06f7&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-314b06f7"

export default script